import apiConfig, {
  ERROR_TIMEOUT,
  ADD_SUCCESS_MESSAGE,
  DEFAULT_ERROR_MESSAGE,
  INVALID_SESSION,
  CASE_TYPE_WITH_DISPLAYSTATUS,
} from "../../App.config";
import setLoaderAction from "./loaderAction";
import types from "../actionTypes";
import * as apiServices from "../../services/apiServices";
import * as toastAction from "../actions/toastAction";
import * as utilities from "../../utilities/utils";
import history from "../../utilities/history";
import { isSessionValid } from "./profileAction";

/************************************ ACTIONS ****************************************/

function setAttachmentManagerAction(attachments) {
  return {
    type: types.SET_ATTACHMENTS,
    attachments,
  };
}

function setTotalRowsAction(totalRows) {
  return {
    type: types.SET_TOTAL_ROWS,
    totalRows,
  };
}

function setCurretPageAction(currentPage) {
  return {
    type: types.SET_CURRENT_PAGE,
    currentPage,
  };
}

function setPageSizeAction(pageSize) {
  return {
    type: types.SET_PAGE_SIZE,
    pageSize,
  };
}

function setIsCustomAttachmentAction(isCustomAttachment) {
  return {
    type: types.IS_CUSTOM_ATTACHMENT,
    isCustomAttachment,
  };
}

function setCaseStatusDetailsAction(caseStatusDeatils) {
  return {
    type: types.SET_CASE_DETAILS_BY_EIN,
    caseStatusDeatils,
  };
}

/************************************ ACTION CREATORS ****************************************/

export const setCaseStatusDetails = (caseStatusDeatils) => (dispatch) => {
  dispatch(setCaseStatusDetailsAction(caseStatusDeatils));
};

export const setCurrentPage = (currentPage) => (dispatch) => {
  dispatch(setCurretPageAction(currentPage));
};

export const setPageSize = (pageSize) => (dispatch) => {
  dispatch(setPageSizeAction(pageSize));
};

export const setIsCustomAttachment = (isCustomAttachment) => (dispatch) => {
  dispatch(setIsCustomAttachmentAction(isCustomAttachment));
};

export const downloadAllAttachments = (ein, isCustomAttachment, profileReducer) => (
  dispatch
) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .downloadAllAttachments(ein, isCustomAttachment, profileReducer)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        utilities.download(
          // data.zipDownloadURI.replace("~/", apiConfig.BASEURL)
          data.zipDownloadURI
        );
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getAttachments = (ein, isCustomAttachment, profileReducer, pagination) => (
  dispatch
) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getAttachments(ein, isCustomAttachment, profileReducer, pagination)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        if (Array.isArray(data.attachments) && data.attachments.length) {
          data.attachments = data.attachments.map((attachment) => {
            // attachment.fullPdfPath = attachment.pdfPath.replace(
            //   "~/",
            //   apiConfig.BASEURL
            // );
            attachment.fullPdfPath = attachment.pdfPath
            return attachment;
          });
        }
        dispatch(setAttachmentManagerAction(data.attachments));
        dispatch(setTotalRowsAction(data?.pagination?.totalRows));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          if (
            (Array.isArray(data.attachments) && data.attachments.length <= 0) ||
            !data.attachments
          ) {
            dispatch(setAttachmentManagerAction([]));
            dispatch(
              toastAction.showErrorMessage(true, "No attachments found")
            );
            dispatch(setTotalRowsAction(0));
          }
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          if (
            (Array.isArray(data.attachments) && data.attachments.length <= 0) ||
            !data.attachments
          ) {
            dispatch(setAttachmentManagerAction([]));
            dispatch(
              toastAction.showErrorMessage(true, "No attachments found")
            );
            dispatch(setTotalRowsAction(0));
          }
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const setAllCaseStatusDetails = (caseStatusDetails) => (dispatch) => {
  dispatch(setCaseStatusDetailsAction(caseStatusDetails));
}

export const getAllCasesDetailsByEin = (ein, pagination,profileReducer) => (dispatch) => {
  dispatch(setLoaderAction(true));
  dispatch(setCaseStatusDetailsAction([]));
  return apiServices
    .getAllCasesDetailsByEin(ein, pagination,profileReducer)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        //TODO
        let caseDtails = [];
        Array.isArray(data.caseStatusDetails) && data.caseStatusDetails.map((caseItem) => {
          let isFoundStatus = 0;
          CASE_TYPE_WITH_DISPLAYSTATUS.map((status) => {
            if (isFoundStatus == 0) {
              if (status.overAllStatusItem == utilities.getInitialFileStatus(caseItem.fileStatusInformation)) {
                //caseItem.fileStatus = status.displayValue;
                caseItem.statusDisplay = status.displayValue;
                isFoundStatus = 1;
              }
              else {
                caseItem.statusDisplay = "-";
              }
            }
          })

          caseDtails.push(caseItem)
        })

        dispatch(setCaseStatusDetailsAction(caseDtails));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          history.push("/applicants");
          // dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          // setTimeout(() => {
          //   dispatch(toastAction.showErrorMessage(false, ""));
          // }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getAllActiveCases = (profileReducer,searchKey=null) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getAllActiveCases(profileReducer,searchKey)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        //TODO
        let caseDtails = [];
        Array.isArray(data.caseStatusDetails) && data.caseStatusDetails.map((caseItem) => {
          let isFoundStatus = 0;
          CASE_TYPE_WITH_DISPLAYSTATUS.map((status) => {
            if (isFoundStatus == 0) {
              if (status.overAllStatusItem == utilities.getInitialFileStatus(caseItem.fileStatusInformation)) {
                //caseItem.fileStatus = status.displayValue;
                caseItem.statusDisplay = status.displayValue;
                isFoundStatus = 1;
              }
              else {
                caseItem.statusDisplay = "-";
              }
            }
          })

          caseDtails.push(caseItem)
        })

        dispatch(setCaseStatusDetailsAction(caseDtails));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          history.push("/applicants");
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getAirAttachments = (ein, isCustomAttachment, pagination) => (
  dispatch
) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getAirAttachments(ein, isCustomAttachment, pagination)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        if (Array.isArray(data.attachments) && data.attachments.length) {
          data.attachments = data.attachments.map((attachment) => {
            // attachment.fullPdfPath = attachment.pdfPath.replace(
            //   "~/",
            //   apiConfig.BASEURL
            // );
            attachment.fullPdfPath = attachment.pdfPath;
            return attachment;
          });
        }
        dispatch(setAttachmentManagerAction(data.attachments));
        dispatch(setTotalRowsAction(data?.pagination?.totalRows));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          if (
            (Array.isArray(data.attachments) && data.attachments.length <= 0) ||
            !data.attachments
          ) {
            dispatch(setAttachmentManagerAction([]));
            dispatch(
              toastAction.showErrorMessage(true, "No attachments found")
            );
            dispatch(setTotalRowsAction(0));
          }
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          if (
            (Array.isArray(data.attachments) && data.attachments.length <= 0) ||
            !data.attachments
          ) {
            dispatch(setAttachmentManagerAction([]));
            dispatch(
              toastAction.showErrorMessage(true, "No attachments found")
            );
            dispatch(setTotalRowsAction(0));
          }
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};
